import React from 'react';
import { ApolloError } from '@apollo/client';
import { Link } from 'react-router-dom';

import { Page, Button, EditIcon, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { ProductCategoryFragment } from '@occc/graphql';

import { ProductCategoryDetails } from './ProductCategoryDetails';
import { getBreadcrumbLinks } from './utils';

import { routeCreator } from '../utils';

interface ProductCategoryDetailsPageProps {
  loading: boolean;
  error?: ApolloError;
  productCategory?: ProductCategoryFragment | null;
  isUserPermittedToEditProductCategory: boolean;
}

export const ProductCategoryDetailsPage: React.FC<ProductCategoryDetailsPageProps> = ({
  loading,
  error,
  productCategory,
  isUserPermittedToEditProductCategory,
}) => {
  const productCategoryName = productCategory?.name;
  const links = React.useMemo(() => getBreadcrumbLinks(productCategoryName), [productCategoryName]);

  useAppLayoutContextConsumer(links);

  const isEditProductCategoryButtonVisible =
    isUserPermittedToEditProductCategory && productCategory;

  const actions = isEditProductCategoryButtonVisible && (
    <Button
      color='secondary'
      variant='contained'
      component={Link}
      to={routeCreator.update(productCategory.id)}
      startIcon={<EditIcon />}
      role='button'
    >
      Edit
    </Button>
  );

  return (
    <Page
      browserTabTitle='Product Preference'
      pageHeaderProps={{ title: 'Product Preference Details' }}
      actions={actions}
      containerProps={{ variant: 'md' }}
    >
      <ProductCategoryDetails loading={loading} error={error} productCategory={productCategory} />
    </Page>
  );
};
